import { MONTHLY_PERIODICITY, YEARLY_PERIODICITY } from "@arbeidsark/shared"
import type { SubscriptionPeriodicity } from "@arbeidsark/shared"
import styled from "styled-components"
import { Button, OutlineButton } from "~/components"
import Radio from "~/components/Radio/Radio"
import { useTranslate } from "~/ur-react-hooks"

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

const Title = styled.h4`
  margin: 0;
  font-size: 18px;
  color: ${(props) => props.theme.colors.gray0};
`

const RadioOptionTitle = styled.h5`
  display: inline-block;
  margin: 0;
  margin-right: 1rem;
`

const RadioCurrent = styled.span`
  display: inline-block;
  font-size: 12px;
  margin-left: 0.5rem;
`

export interface SelectSubscriptionProps {
  value: SubscriptionPeriodicity
  onChange: (value: SubscriptionPeriodicity) => void
  onNext: () => void
  isLoading?: boolean
  buttonText?: string
  currentSubscription?: SubscriptionPeriodicity
  buttonType?: "regular" | "outline"
}

const SelectSubscription: React.FC<SelectSubscriptionProps> = ({
  value,
  onChange,
  onNext,
  isLoading: loading,
  buttonText,
  currentSubscription,
  buttonType,
}) => {
  const translations = useTranslate({
    title: "select-subscription.title",
    price: ["common.price-per-month", { price: 0 }],
    yearly: "common.yearly",
    monthly: "common.monthly",
    next: "common.next",
    current: "subscriptions.current-subscription",
  })

  const ResolvedButtonClass = buttonType === "outline" ? OutlineButton : Button

  return (
    <Layout>
      <Title>{translations.title}</Title>
      <Radio
        checked={value === YEARLY_PERIODICITY}
        onChange={(value) =>
          onChange(value ? YEARLY_PERIODICITY : MONTHLY_PERIODICITY)
        }
      >
        <RadioOptionTitle>{translations.yearly}</RadioOptionTitle>
        {translations.price({ price: 249 })}
        {currentSubscription === YEARLY_PERIODICITY && (
          <RadioCurrent>({translations.current})</RadioCurrent>
        )}
      </Radio>
      <Radio
        checked={value === MONTHLY_PERIODICITY}
        onChange={(value) =>
          onChange(value ? MONTHLY_PERIODICITY : YEARLY_PERIODICITY)
        }
      >
        <RadioOptionTitle>{translations.monthly}</RadioOptionTitle>
        {translations.price({ price: 299 })}
        {currentSubscription === MONTHLY_PERIODICITY && (
          <RadioCurrent>({translations.current})</RadioCurrent>
        )}
      </Radio>
      <ResolvedButtonClass disabled={loading} onClick={onNext}>
        {buttonText ?? translations.next}
      </ResolvedButtonClass>
    </Layout>
  )
}

export default SelectSubscription
